module.exports = __webpack_public_path__ + "img/template-3.a2f64f31.jpg";